<template>

    <div class="test-123456">

        <div v-if="dataStore.currentOpinion && Array.isArray(dataStore.currentOpinion) && !dataStore.addToExistingWindow" class="window view-comment">

            <nav v-if="dataStore.currentOpinion.length > 1">

                <div>

                    <button :title="language.previous" class="btn btn-secondary btn-sm" v-on:click="goBack">{{ language.previous }}</button>

                    <button :title="language.next" class="btn btn-secondary btn-sm" v-on:click="goToNext">{{ language.next }}</button>

                </div>

                <div>
                    {{ language.showing_responses.replacePlaceholders({ number : dataStore.activeItem + 1, of : dataStore.currentOpinion.length }) }}
                </div>

            </nav>

            <div class="show-pin" :class="{ active: index === dataStore.activeItem || dataStore.currentOpinion.length === 0 }" v-for="(opinion, index) in dataStore.currentOpinion" :key="index">

                <span :title="language.close" class="close-popup" @click="closeWindow"><i class="fas fa-times"></i></span>

                <div :class="opinion.value_type === 'bad' ? 'opinion bad-opinion' : 'opinion'">

                    <div v-if="opinion.comment || opinion.image" class="top">

                        <p>{{ opinion.comment }}</p>

                        <div v-if="opinion.image && opinion.image.name !== '' ">
                            <img class="answer-image" :src="'/images/projects/answer-images/' + getNameAndExt(opinion.image).name + '_300.' + getNameAndExt(opinion.image).ext" />
                        </div>
                    </div>

                    <span v-if="showIp">
                        <pre>
                            ip : {{ opinion.answer_data.ip }}
                            answer_data_id : {{ opinion.answer_data.id }}
                            answer_id : {{ opinion.id }}
                        </pre>
                    </span>

                    <div :class="(opinion.value_type === 'good' || opinion.value_type === 'bad' ? 'bottom' : 'bottom no-after')">

                        <div :class="(opinion.value_type === 'good' || opinion.value_type === 'bad' ? 'good-bad' : 'good-bad no-value')">{{  getLabelForGoodBad( language, dataStore.currentSlide, opinion.value_type ) }}</div>

                        <ul v-if="opinion.values.length > 0" class="options">
                            <li v-for="(val, i) in filterListingOptions(opinion.values, slide)" :key="i">#{{ val.val }}</li>
                        </ul>

                        <div class="info">
                            <div v-if="dataStore.project.hide_sex && opinion.answer_data && opinion.answer_data.sex" :class="(opinion.values && opinion.values.length) ? 'sex' : 'sex no-options'">{{ opinion.answer_data.sex }}</div>
                            <div v-if="dataStore.project.hide_ages && opinion.answer_data && opinion.answer_data.age" class="age">{{ opinion.answer_data.age }} {{ language.years }}</div>
                            <div v-if="dataStore.project.hide_types && opinion.answer_data && opinion.answer_data.type" class="type">{{ opinion.answer_data.type }}</div>
                        </div>

                        <div class="time-wrapper">

                            <div class="time" v-if="opinion.answer_data && opinion.answer_data.created_date">{{ opinion.answer_data.created_date }}</div>

                            <div class="actions">

                                <a v-if="project.hide_share && opinion.deep_link" :title="language.share " v-on:click.prevent="copyStringToClipboard(opinion)" class="action" :href="opinion.deep_link">{{ language.share }}</a>

                                <a v-if="(!dataStore.reported.includes(opinion.id) && project.hide_report) && project.welcome_mode !== 'END'" title="Anmäl" href="#" class="action report-link" v-on:click.prevent="reportArea(opinion.id)">{{ language.report }}</a>

                                <add-on-existing v-if="project.welcome_mode !== 'END'" :marker="opinion" :project="project" :slide="slide" ></add-on-existing>

                            </div>

                            <p v-if="copytext" class="copy-text-share">{{copytext}}</p>

                        </div>

                    </div>

                </div>

                <p class="report-link" v-if="dataStore.reported.includes(opinion.id) && project.hide_report">{{ language.has_been_reported }}</p>

                <report v-if="project.hide_report && dataStore.currentToReport === opinion.id" />

            </div>

        </div>

        <div v-if="dataStore.addToExistingWindow" class="window comment-on" >

            <form-pop-up
                :slide="slide"
                :parentslug="project.slug"
                :index="index"
                @close-popup="closePopup"
            />

        </div>

    </div>

</template>

<script>

import Slick from "vue-slick";
import dataStore from "../../store";

import Report from './Report'
import AddOnExisting from './AddOnExisting'
import FormPopUp from "./FormPopUp";

import { slickOptionsOpinion }from "../../settings";
import { getLabelForGoodBad } from './../../translations'
import { showReportArea, filtredOptions, getFileInfo } from './../../functions'
import { Fragment } from 'vue-fragment'

export default {

    components: {
        Report,
        AddOnExisting,
        Slick,
        Fragment,
        FormPopUp
    },

    inject: [ 'language' ],

    data() {
        return {
            dataStore,
            slickOptions: slickOptionsOpinion,
            todayDate : new Date(),
            copytext : '',
            showIp : false,
            getLabelForGoodBad
        };
    },

    props: {
        project: Object,
        slide : Object,
        index: Number
    },

    mounted() {

        if(window.location.search.includes('show_ip=true')) {
            this.showIp = true;
        }

    },

    computed : {

        shareLink : function() {

            const language = {
                en : '/view-comments/comment/',
                sv : '/se-synpunkter/synpunkt/',
                fr : '/voir-les-commentaires/comment/',
                de : '/kommentare-ansehen/comment/',
            }

            return window.location.origin + '/' + this.project.slug + language[this.project.language.code]
            
        }

    },

    methods: {

        closePopup: function() {
            this.$emit('close-popup')
        },

        getNameAndExt: function(file) {
            return getFileInfo(file)
        },

        filterListingOptions: function() {
            return filtredOptions.apply(null, arguments)
        },

        reportArea: function(id) {
            return showReportArea(id)
        },

        closeWindow: function() {

            this.dataStore.infoWinOpen = false;

            this.dataStore.forceCloseInfoWindow = true;

            this.dataStore.feedbackOverride = false;

            this.dataStore.showReportWindow = false

            document.body.classList.remove('comment-window-open', 'report');

            let answers = this.dataStore.collectedAnswers.filter(a => a.addOnExisting);

            if( answers.length ) {
                this.dataStore.collectedAnswers.pop();
                this.dataStore.addToExistingWindow = false
            }

            this.$emit('close-popup')

        },

        goBack: function() {

            this.dataStore.activeItem = this.dataStore.activeItem - 1;

            if(this.dataStore.activeItem < 0) {
                this.dataStore.activeItem = this.dataStore.currentOpinion.length - 1;
            }

        },

        goToNext: function() {

            this.dataStore.activeItem = this.dataStore.activeItem + 1;

            if(this.dataStore.activeItem === this.dataStore.currentOpinion.length) {
                this.dataStore.activeItem = 0;
            }
        },

        copyStringToClipboard: function (opinion) {

            try {
                // Create new element
                var el = document.createElement('textarea');
                // Set value (string to be copied)
                el.value = this.shareLink + opinion.deep_link;
                // Set non-editable to avoid focus and move outside of view
                el.setAttribute('readonly', '');
                el.style = {position: 'absolute', left: '-9999px'};
                document.body.appendChild(el);
                // Select text inside element
                el.select();
                // Copy text to clipboard
                document.execCommand('copy');
                // Remove temporary element
                document.body.removeChild(el);

                this.copytext = this.language.link_copied;

            } catch (error) {
                this.copytext = this.language.something_went_wrong;

            }

            setTimeout(() => { this.copytext = '' }, 3000);

        }

    }
};
</script>


